import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";

const Thankyousubbanner = () => {
  const navigate = useNavigate();

  // One-time auto refresh using sessionStorage
  useEffect(() => {
    const hasRefreshed = sessionStorage.getItem("hasRefreshedThankYou");
    if (!hasRefreshed) {
      sessionStorage.setItem("hasRefreshedThankYou", "true");
      window.location.reload();
    }
  }, []);

  return (
    <section className="thank-you position-relative">
      <div className="container">
        <div className="row">
          <div className="col-lg-8 col-12 mx-auto">
            <div className="thank_you_content text-center" data-aos="fade-up">
              <figure className="thankyou-image">
                <img src="assets/images/thankyou-image.png" alt="image-0" className="img-fluid" />
              </figure>
              <h1>Thank You!</h1>
              <p>
                We're delighted you've decided to treat yourself to our delightful candies.
                Your order has been received and is now being packed with care.
              </p>
              <button
                onClick={() => navigate("/")}
                className="text-decoration-none all_button"
                style={{ border: "none" }}
              >
                <i className="fa-solid fa-arrow-left"></i> Back to Home
              </button>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Thankyousubbanner;
